





import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../../../components/system";
import { FormatStructureEditableMixin } from "../../mixins";
import { FormatPageStructureEditor } from "../../../../../domain/editableFormat";

@Component
export default class ObjectIdPublisher extends Mixins(ModelEditableMixin, FormatStructureEditableMixin) {
  data() {
    return {
      objectId: null as number,
    };
  }
  objectId: number;

  get latestMaxObjectId(): number {
    const initialId = !this.lastMaxObjectId ? this.getMaxObjectId(this.pages) : this.lastMaxObjectId;
    return !this.objectId ? initialId : this.objectId;
  }

  set latestMaxObjectId(id: number) {
    this.objectId = id;
  }

  publish(): number {
    this.latestMaxObjectId += 1;
    return this.latestMaxObjectId;
  }

  private getMaxObjectId(page: FormatPageStructureEditor[]): number {
    return Enumerable.from(page)
      .selectMany(p => p.getObjects())
      .where(o => !!o && !!o.id)
      .select(o => o.id().getValue())
      .concat([0]) // idがあるオブジェクトが存在しないとmaxが例外投げてしまうので0を追加しておく.
      .max();
  }
}
